import React from 'react';
import { useTranslation } from 'react-i18next';
import { Preloader } from '@common-fe/common-fe';

import { Roles } from '@/common/constants';
import ROUTES from '@/common/routes';
import { useBreadcrumbs, useHasAccess, useRedirectHome } from '@/modules/core/hooks';
import { MyDocuments } from '@/modules/MyDocuments';
import { useAuthStore } from '@/modules/user/stores';

const MyDocumentsPage = () => {
  const { t } = useTranslation();
  const { user } = useAuthStore();

  const isMyDocumentsDisabled = useHasAccess([{
    role: Roles.employeeLimitedAccess,
  }]);

  useRedirectHome(isMyDocumentsDisabled);

  useBreadcrumbs([
    {
      key: ROUTES.HOME,
      title: t('Home'),
      value: ROUTES.HOME,
    },
    {
      key: ROUTES.MY_DOCUMENTS,
      title: t('My Documents'),
      value: ROUTES.MY_DOCUMENTS,
    }
  ], true);

  if (!user) return <Preloader />;

  return <MyDocuments />;
};

export default MyDocumentsPage;
